import React from 'react';
import { useTranslation } from 'react-i18next';
import getTabBarItems from '../../utils/helpers/getTabBarItems';
import { TabBarItemServer } from './TabBarItemServer';
import { ICustomTabBarItem } from './types';
import { TabBarContainer, TabBarWrapper, TabBarList } from './styled';

export const TabBarNavigationServer: React.FC = () => {
  const { t } = useTranslation();
  const tabBarItems = getTabBarItems(t) as ICustomTabBarItem[];

  return (
    <TabBarContainer>
      <TabBarWrapper>
        <TabBarList>
          {tabBarItems.map((item, i) => (
            <TabBarItemServer key={`item_${i}`} item={item} />
          ))}
        </TabBarList>
      </TabBarWrapper>
    </TabBarContainer>
  );
};
